import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import { observer } from "mobx-react";
import { useStores } from "../../../store";
import { __, _i } from "../../../utils";
import { App, Tooltip } from "antd";
import { SyncOutlined } from "@ant-design/icons";
const DashboardServiceCloudCardContent = observer(()=>{
    const { message } = App.useApp();
    const { cookieStore, optionStore } = useStores();
    const { busySettings, others: { isPro, isLicensed }, cloudReleaseInfo: { blocker, service } } = optionStore;
    const [isSyncing, setIsSyncing] = useState(false);
    const handleSync = useCallback(async ()=>{
        if (isSyncing) {
            return;
        }
        setIsSyncing(true);
        try {
            await cookieStore.fetchTemplatesServices({
                storage: "redownload"
            });
            await cookieStore.fetchTemplatesBlocker();
            await optionStore.fetchCurrentRevision();
            message.success("Template database successfully updated. You can see the latest templates now!");
        } catch (e) {
            message.error(e.responseJSON.message);
        } finally{
            setIsSyncing(false);
        }
    }, [
        isSyncing
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "description",
                children: __("Templates for hundreds of services that you could be running on your website must be downloaded from Real Cookie Banner's Service Cloud. The data will be downloaded locally to your server, so your website visitors will not need to connect to the cloud.")
            }),
            isLicensed ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    blocker ? /*#__PURE__*/ _jsx("p", {
                        className: "description",
                        children: _i(__("You have downloaded the service templates the last time on {{u/}}"), {
                            u: /*#__PURE__*/ _jsx(Tooltip, {
                                title: /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        /*#__PURE__*/ _jsx("strong", {
                                            children: __("Services")
                                        }),
                                        /*#__PURE__*/ _jsx("br", {}),
                                        __("Release ID"),
                                        ": ",
                                        service == null ? void 0 : service.releaseId,
                                        /*#__PURE__*/ _jsx("br", {}),
                                        __("Pre-release"),
                                        ":",
                                        " ",
                                        (service == null ? void 0 : service.isPreReleaseEnabled) ? __("Yes") : __("No"),
                                        /*#__PURE__*/ _jsx("br", {}),
                                        /*#__PURE__*/ _jsx("strong", {
                                            children: __("Content Blocker")
                                        }),
                                        /*#__PURE__*/ _jsx("br", {}),
                                        __("Release ID"),
                                        ": ",
                                        blocker == null ? void 0 : blocker.releaseId,
                                        /*#__PURE__*/ _jsx("br", {}),
                                        __("Pre-release"),
                                        ":",
                                        " ",
                                        (blocker == null ? void 0 : blocker.isPreReleaseEnabled) ? __("Yes") : __("No")
                                    ]
                                }),
                                children: /*#__PURE__*/ _jsx("u", {
                                    style: {
                                        textDecoration: "none",
                                        borderBottom: "1px dotted #000",
                                        cursor: "help"
                                    },
                                    children: new Date(blocker.downloadTime).toLocaleString(document.documentElement.lang)
                                })
                            })
                        })
                    }) : busySettings ? null : /*#__PURE__*/ _jsx("div", {
                        className: "notice notice-error inline below-h2 notice-alt",
                        style: {
                            margin: "10px 0"
                        },
                        children: /*#__PURE__*/ _jsx("p", {
                            className: "description",
                            children: __('An error occurred when trying to download the templates from the Service Cloud for the first time. This means that the scanner will currently not be able to suggest scan results for service templates. The download will be performed again automatically in a few minutes, or click "Update templates" below.')
                        })
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        children: /*#__PURE__*/ _jsx(Tooltip, {
                            title: __('The template database is downloaded to your WordPress and is updated daily. Click "Update templates" to download the latest version now!'),
                            placement: "bottom",
                            children: /*#__PURE__*/ _jsxs("a", {
                                type: "button",
                                className: `button ${isSyncing ? "button-disabled" : ""}`,
                                onClick: handleSync,
                                children: [
                                    /*#__PURE__*/ _jsx(SyncOutlined, {
                                        spin: isSyncing
                                    }),
                                    "\xa0",
                                    __("Update templates")
                                ]
                            })
                        })
                    })
                ]
            }) : busySettings ? null : /*#__PURE__*/ _jsx("div", {
                className: "notice notice-warning inline below-h2 notice-alt",
                style: {
                    margin: "10px 0"
                },
                children: /*#__PURE__*/ _jsxs("p", {
                    className: "description",
                    children: [
                        __("This functionality is only available with a valid license, as the service templates must be downloaded regularly from our cloud service."),
                        " ",
                        "•",
                        " ",
                        /*#__PURE__*/ _jsx("a", {
                            href: `#/licensing?navigateAfterActivation=${encodeURIComponent(window.location.href)}`,
                            children: isPro ? __("Activate license") : __("Activate free license")
                        })
                    ]
                })
            })
        ]
    });
});
export { DashboardServiceCloudCardContent };
